// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 4701 ? "svg-icons" : chunkId) + "." + {"735":"874e01d3","2803":"3803ddae","4701":"fc7ad385","5815":"a1b8b289","8061":"ddfc5784"}[chunkId] + ".chunk.js";
};